module.exports = __webpack_public_path__ + "img/wheel.11fc429b.png";